import { generateNumbers } from '../../../common/fetch';
import { OrderItemUnit } from '../../../generated/api/orderItemUnit';
import type { PlaceOrderItemUnit } from '../placeOrderTypes';

/**
 * Replaces unavailable phone numbers with newly generated ones in order item units.
 * Only replaces NEW numbers (not ported), and only those that are in the unavailable list.
 *
 * @param orderItemUnits - Current order item units with phone numbers
 * @param unavailableNumbers - List of phone numbers that are no longer available
 * @returns Updated order item units with replacement numbers
 */
export const replaceUnavailableNumbers = async (
  orderItemUnits: PlaceOrderItemUnit[],
  unavailableNumbers: string[]
): Promise<PlaceOrderItemUnit[]> => {
  if (unavailableNumbers.length === 0) {
    return orderItemUnits;
  }

  // Generate new numbers to replace unavailable ones
  const response = await generateNumbers({ count: unavailableNumbers.length });
  const replacementNumbers = [...response.numbers];

  // Create updated order item units with replacements
  const updatedUnits = orderItemUnits.map(unit => {
    // Only replace if this is a NEW number and it's in the unavailable list
    if (
      unit.mobileNumber &&
      unit.numberPorting === OrderItemUnit.NumberPortingEnum.NEW_NUMBER &&
      unavailableNumbers.includes(unit.mobileNumber)
    ) {
      const newNumber = replacementNumbers.shift();
      if (newNumber) {
        return {
          ...unit,
          mobileNumber: newNumber,
        };
      }
    }
    return unit;
  });

  return updatedUnits;
};
